import "./Textarea.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../_utils/component");

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var id = 0;
var __vue_script__ = {
  name: (0, _component.createComponentName)('textarea'),
  mixins: [_component.componentMixin],
  model: {
    name: 'value',
    event: 'input'
  },
  props: {
    resize: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String
    },
    maxWordCount: {
      type: [Number, Boolean],
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      privateValue: this.$hasProp('value') ? this.value : this.$hasProp('defaultValue') ? this.defaultValue : '',
      textareaCalcStyle: {},
      prefixOffset: null,
      suffixOffset: null,
      hovering: false,
      focused: false,
      isError: false
    };
  },

  watch: {
    value(v) {
      this.privateValue = v;
    }

  },

  created() {
    if (!this.$hasProp('id')) {
      this.__id = 'gd-textarea-id-' + id++;
    }
  },

  methods: {
    handleInput(event) {
      var value = event.target.value;
      this.privateValue = value;
      this.$emit('input', value, event);
    },

    handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },

    handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },

    handleChange(event) {
      var value = event.target.value;
      this.privateValue = value;
      this.$emit('change', value, event);
    },

    handleEnter(event) {
      this.$emit('enter', event);
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem({
      resize: _vm.resize
    })
  }, [_vm.label ? _c("label", {
    class: _vm.bem("label"),
    attrs: {
      for: _vm.id || _vm.__id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c("textarea", _vm._b({
    class: _vm.bem("inner", {
      focus: _vm.focused,
      tip: _vm.maxWordCount
    }),
    attrs: {
      id: _vm.id || _vm.__id,
      placeholder: _vm.placeholder,
      rows: "4"
    },
    domProps: {
      value: _vm.privateValue
    },
    on: {
      input: _vm.handleInput,
      change: _vm.handleChange,
      focus: _vm.handleFocus,
      blur: _vm.handleBlur,
      keypress: function keypress($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    }
  }, "textarea", _vm.$attrs, false)), _vm._v(" "), _vm.maxWordCount ? _c("div", {
    class: _vm.bem("word-count", {
      error: _vm.privateValue.length > _vm.maxWordCount
    })
  }, [_vm._v("\n        " + _vm._s(_vm.privateValue.length) + "/" + _vm._s(_vm.maxWordCount) + "\n    ")]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;